<template>
	<div id="upload-image-wrapper" v-loading="uploading" class="upload-image-wrapper video_box_big" @blur="blur" @click="add_img" @focus="focus">
		<!-- multiple 设置多张选择为true 则为false  -->
		<el-upload
			key="rowId_ref"
			ref="elUpload"
			:auto-upload="false"
			action=""
			:before-upload="beforeUpload"
			:class="[fileList.length == maxLimit || fileList.length > maxLimit  || fileList.length == 0 ?  'hidden-Btn' : '']"
			:file-list="fileList"
			:limit="maxLimit"
			:multiple="true"
			:on-change="handleChange"
			:on-exceed="handleExceed"
			:on-preview="handlePreview"
			:on-remove="handleRemove"
			:on-success="handleSuccess"
			:accept="thatAcceptType"
			:show-file-list="false"
			list-type="text">
			<!-- hidden-Btn -->
			<!-- <div class="paste-tip">
			  <i class="el-icon-plus upload-icon"></i>
			</div> -->
		</el-upload>
		
		<!-- 视频预览逻辑 -->
		<div class="video_box">
			<div class="el-upload-list__item" v-for="(file, index) in fileList" :key="file.name">
				<video v-if="file.url" :src="file.url" controls class="el-upload-list__item-thumbnail" style="max-width: 100%;"></video>
				<span v-else>{{ file.name }}</span>
			 
				<div class="icon_box_big">
					<div class="icon_box_show">
						<div class="icon_box">
							<div class="icon" @click.stop="handlePreview(file)"><i class="el-icon-circle-plus-outline"></i></div>
							<div class="icon" @click.stop="handleRemove(file, fileList)"><i class="el-icon-delete"></i></div>
						</div>
					</div>
				</div>
				
				<div class="item-status-label">
					<i class="el-icon-upload-success el-icon-check"></i>
				</div>
				
			</div>
			
			<div v-show="fileList.length < maxLimit  && fileList.length > 0" class="div-paste-tip" @click.stop="triggerPicsUpload()">
			  <i class="el-icon-plus upload-icon"></i>
			</div>
		</div>
		
		<!-- 点击查看放大 -->
		<el-dialog :visible.sync="dialogVisible" width="100%" top="0" @click.stop>
			<video :src="dialogUrl" controls class="preview-video"></video>
			<!-- <div class="dialog-controls">
				<button type="button" @click.stop="prevImage" :disabled="currentImageIndex === 0"><i class="el-icon-arrow-left"></i></button>
				<button type="button" @click.stop="nextImage" :disabled="currentImageIndex === fileList.length - 1"><i class="el-icon-arrow-right"></i></button>
			</div> -->
		</el-dialog>
		
		<div class="LoadingBox" v-if="Loading">
			<Loading :LoadingText="LoadingText"></Loading>
		</div>
		
		<handlePreviewSwiper v-if="handlePreviewShow" :fileList="PreviewSwiper" :currentUrl="currentUrl" :itemtype="swiperSlide" @closurePreview="handlePreviewShow = false"></handlePreviewSwiper>
			
	</div>
</template>

<script>
import { post_community_upload } from '@/api/community.js'
// import handlePreviewSwiper from '../public/handlePreviewSwiper.vue';
		
	var that
	export default {
		name: "VideosUpload",
		// components: { handlePreviewSwiper },
		
		props: {
			uploadType: {
				type: Number,
				default: 1,  // 必填 1图文, 2视频
			},
			maxFileList: {
				type: Number,
				default: 9,  // 最多
			},
			acceptType: {
				type: String,
				default: "image/jpeg, image/png, image/webp",
			},
			FileList: {
				type: Array,
				default() {
					return []
				}
			},
		},
		
		data() {
			return {
				uploadUrl: "1", // 上传截图相关数据
				screenshotUrl_arr: [],
				dialogUrl: "",
				dialogVisible: false,
				// 粘贴上传数据
				fileList: this.FileList,
				uploading: false,
				maxLimit: this.maxFileList,
				thatAcceptType: this.acceptType,
				Loading: false,
				LoadingText: false,
				triggerPicsUploadCopy: this.triggerPicsUpload,
				currentImageIndex: 0, // 当前显示的图片索引
				PreviewSwiper:[],
				currentUrl: "",
				handlePreviewShow: false,
				swiperSlide: "",
			}
		},
		
		watch: {
			"acceptType": {
				handler: function (val, oldval) {
					this.thatAcceptType = this.acceptType
				}
			},
			// "fileList": {
			// 	handler: function (val, oldval) {
			// 		console.log(this.fileList)
			// 		if (this.fileList.length == 0) {
			// 			this.uploadDisabled = 0
			// 		} else {
			// 			this.uploadDisabled = this.fileList.length
			// 		}
			// 	},
			// 	deep: true,
			// },
			"FileList": {
				handler: function (val, oldval) {
					this.fileList = this.FileList
				}
			},
		},
		
		beforeCreate() {
			// const vm = this
		},

		created() {

		},

		beforeDestroy() {

		},
		
		mounted() {
			that = this
			// 将触发方法绑定到父组件的函数上
			if (this.triggerPicsUploadCopy) {
				this.triggerPicsUploadCopy = this.triggerPicsUploadCopy.bind(this); // 绑定 this
				this.$refs.elUpload.$on('click', this.triggerPicsUploadCopy); // 使用 copy 属性
			}
			
			this.$nextTick(() => {
				this.set_upload_input_files()
			})
			// 点击上传区域后延迟重新赋值
			this.$el.addEventListener('click', () => {
				setTimeout(() => this.set_upload_input_files(), 30)
			})
		},
		
		methods: {
			set_upload_input_files(){
				// 精准选中当前组件内上传文件input
				const fileInput = this.$el.querySelector('.video_box_big .el-upload__input')
				if (fileInput) {
					fileInput.setAttribute('aria-label', 'Upload video files for community post')
				}
			},
			OpenPreviewSwiper(fileList, item, swiperSlide){
				// let currentRouteName = this.$route.name;
				// if(currentRouteName != 'PostDetails'){ return }
				this.PreviewSwiper = fileList
				this.currentUrl = item
				this.handlePreviewShow = true
				this.swiperSlide = swiperSlide
			},
			triggerPicsUpload() {
			   // 手动触发 el-upload 的点击事件，打开文件选择框
			   this.$refs.elUpload.$el.querySelector('input[type="file"]').click(); // 手动触发 input 的点击事件
			},
			
			add_img() {
				console.log(this.FileList)
				if (this.FileList && this.FileList != 0) {
					// this.$message('一个产品只能上传一张图片哦', 'warn')
				}
			},
			
			// 失去焦点
			blur() {

			},

			// 获取焦点
			focus() {

			},

			// 过滤不符合条件图片
			FormatSize(file, fileList) {
				const index = fileList.findIndex((ele) => {
					return ele.url === file.url
				})
				// 当查找失败返回
				if (index === -1) {
					return console.log("删除失败")
				}
				// 如果找到该元素，使用splice方法删除元素
				return index
			},
			
			get_type(file, type, size, funName, fileList){
				let isType = ""
				let isMax = ""
				let formatText = ""
				let sizeText = ""
				if(this.uploadType == 1){
					isType = type === "image/jpeg" || type === "image/png" || type === "image/jpg" || type === "image/git" || type === "image/bmp" || type === "image/webp"
					isMax = size / 1024 / 1024 < 20 //图片20M
					
					formatText = `${this.$t('FileUploadArr.image_formats')} JPG, JPEG, PNG!`
					sizeText = `${this.$t('FileUploadArr.image_size')} 20MB!`
				}else if(this.uploadType == 2){
					isType = type === "video/mp4"
					isMax = size / 1024 / 1024 < 60 //视频60M
					
					formatText = `${this.$t('FileUploadArr.video_formats')} MP4!`
					sizeText = `${this.$t('FileUploadArr.video_size')} 60MB!`
				}
				
				if (!isType) {
					if(funName == "handleChange"){
						let index = this.FormatSize(file, fileList)
						fileList.splice(index, 1)
					}
					this.$message(formatText, "error")
					return false
				}
				if (!isMax) {
					if(funName == "handleChange"){
						let index = this.FormatSize(file, fileList)
						fileList.splice(index, 1)
					}
					this.$message(sizeText, "error")
					return false
				}
				if(funName == "handleChange" && (isType || isMax)){
					this.post_community_upload(file.raw)
				}
				
			},

			// 上传处理
			async handleChange(file, fileList) {
			   this.get_type(file, file.raw.type, file.size, 'handleChange', fileList);
			// 	// 获取图片宽高
			//    const getImageDimensions = async (file) => {
			//       return new Promise((resolve, reject) => {
			//          const reader = new FileReader();
			//          reader.onload = function (e) {
			//             const img = new Image();
			//             img.onload = function () {
			//                const width = img.width;
			//                const height = img.height;
			//                console.log('图片宽度:', width, '图片高度:', height);
			//                resolve({ width, height });
			//             };
			//             img.src = e.target.result;
			//          };
			//          reader.onerror = (error) => {
			//             reject(error);
			//          };
			//          reader.readAsDataURL(file.raw);
			//       });
			//    };
			
			//    try {
			//       const dimensions = await getImageDimensions(file);
			//       const { width, height } = dimensions;
			//       this.get_type(file, file.raw.type, file.size, 'handleChange', fileList, width, height);
			//    } catch (error) {
			//       console.error('获取图片宽高出错:', error);
			//    }
			},

			// 超量提醒
			handleExceed() {
				this.$message(`${this.$t('FileUploadArr.video_max_text')}  ${this.maxLimit} ${this.$t('FileUploadArr.video_files')}`, "warn")
				// this.$message(`You can only upload up to  ${this.maxLimit} video files`, "warn")
			},

			// 上传成功   暂时无作用
			handleSuccess(res, file) {

			},

			// 删除已经上传好的照片中的照片 this.fileList
			handleRemove_file(file) {
				console.log(file)
				console.log(this.fileList)
				let index = this.fileList.findIndex((ele) => {
					return ele.uid === file.uid
				})
				//当查找失败返回
				if (index === -1) {
					return console.log("删除失败")
				}
				//如果找到该元素，使用splice方法删除元素
				this.fileList.splice(index, 1)
			},

			// 删除图片
			handleRemove(file, fileList) {
				this.handleRemove_file(file)
				// 传下去的fileList会被复制，当删除时，此组件的fileList不会被同步修改，需要手动清空
				var arr = []
				fileList.forEach((item) => {
					//截取是为去掉添加的http://
					let url = item.url.slice(7, item.url.length)
					arr.push(url)
				})
			  if(file){
				 var url = file.url ? file.url : ''
				 this.$emit("remove_videos", url)
			  }
			},

			//上传时验证图片格式
			beforeUpload(file) {
				// return this.get_type(file, file.type, file.size, 'beforeUpload')
			},
			
			//上传文件
			post_community_upload(fileRaw){
				console.log(fileRaw)
			   this.Loading = true
				const fd = new window.FormData()
				fd.append("file[]", fileRaw)//文件
				post_community_upload(fd)
			   .then((res) => {
					console.log(res)
					if(res.code == 0){
						console.log('上传成功')
						let obj = res.data.list[0]
						this.$emit("save_videos", obj)
					}else{
						this.exception_handling(res, "upload", fileRaw)
					}
					this.Loading = false
			   })
			   .catch((err) => {
					console.log(err)
					this.exception_handling(err, "upload", fileRaw)
			   })
			},
			
			//异常处理
			exception_handling(err, type, fileRaw){
				this.Loading = false
				// this.handleRemove_file(fileRaw)
				this.fileList = []
				this.$errorMessage(err)
				// this.$message('err.data.message', 'error')
			},

			// 点击查看大图
			handlePreview(file) {
				// 整理数据结构兼容帖子列表的结构
				let videos = []
				console.log(file)
				console.log(this.fileList)
				this.fileList.forEach((item) => {
					videos.push(item.url)
				})
				let fileList = {
				   videos: videos, //视频
				   video_cover: this.fileList[0].video_cover, //视频封面
					post_type: 2, //类型
				   SlideTotal: this.fileList.length,
				   pics: []
				}
				console.log(fileList)
				this.OpenPreviewSwiper(fileList, file.url, 'UploadVideos')
				// this.currentImageIndex = this.fileList.findIndex(f => f.uid === file.uid);
				// this.dialogUrl = file.url || file.response.url;
				// this.dialogVisible = true;
			},
			
			nextImage() {
				if (this.currentImageIndex < this.fileList.length - 1) {
					this.currentImageIndex++;
					this.dialogUrl = this.fileList[this.currentImageIndex].url || this.fileList[this.currentImageIndex].response.url;
				}
			},
			
			prevImage() {
				if (this.currentImageIndex > 0) {
					this.currentImageIndex--;
					this.dialogUrl = this.fileList[this.currentImageIndex].url || this.fileList[this.currentImageIndex].response.url;
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	.upload-image-wrapper {
		display: block;
		vertical-align: top;
		::v-deep .el-upload--picture-card {
			height: 80px;
			width: 80px;
			line-height: 80px;
			/* background: linear-gradient(rgba(245,245,245,0.6), rgba(245,245,245, 0.6)), url('../../../../../public/img/logo.jpg') no-repeat 100% 100%; */
			background-size: 100% 100%;
			border-radius: 5px;
		}

		::v-deep .el-upload-list--picture-card .el-upload-list__item {
			height: 80px;
		   width: 80px;
		}

		::v-deep .el-upload-list--picture-card .el-upload-list__item-actions {
			height: 80px;
		}
		::v-deep .el-icon-plus.upload-icon {
			/* line-height: 30px; */
			color: #606266;
		}

		::v-deep .paste-tip {
			width: 80px;
			display: flex;
			z-index: 99;
			height: 80px;
			font-weight: 600;
			font-size: 28px;
			background-color: #fbfdff;
			border: 1px dashed #c0ccda;
			border-radius: 4px;
			cursor: pointer;
			color: #99a9bf;
			color: #606266;
			display: flex;
			justify-content: center;
			align-items: center;

			.el_icon {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
		
		.div-paste-tip {
			cursor: pointer;
			height: 80px;
			width: 80px;
			border-radius: 8px;
			line-height: 80px;
			font-weight: 600;
			font-size: 28px;
			color: #99a9bf;
			color: #606266;
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #fbfdff;
			 border: 1px solid #c0ccda;
			 border-radius: 6px;
			 box-sizing: border-box;
		
			.el_icon {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
		::v-deep .hidden-Btn .el-upload--picture-card{
			display: none !important;
		}
  }

  .hidden-Btn {
    ::v-deep .el-upload {
      display: none;
    }
	 .paste-tip{
      display: none;
	 }
  }

  ::v-deep  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 35px;
  }
  ::v-deep .el-dialog {
	  height: 100vh;
	  margin: 0px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  ::v-deep .el-dialog__body {
    width: 100vw;
	 height: 100%;
    max-height: calc(100vh - 30px);
    box-sizing: border-box;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .preview-video{
	 height: 100%;
    max-height: 80vh;
  }
  .dialog_img{
    max-width: 100%;
    height: auto;
  }
  .LoadingBox{
	  position: fixed;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  z-index: 999;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  background-color: rgba(0,0 0, 0.5);
  }
  .dialog-controls {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .dialog-controls button {
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
	 width: 40px;
	 height: 40px;
	 border-radius: 40px;
	 display: flex;
	 justify-content: center;
	 align-items: center;
    cursor: pointer;
	 font-size: 25px;
  }
  .dialog-controls button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .video_box{
	  display: flex;
	  flex-wrap: wrap;
  }
  .el-upload-list__item {
      margin-bottom: 10px;
		margin-right: 10px;
      width: 80px;
      height: 80px;
      overflow: hidden;
		position: relative;
		margin-top: 0px;
		display: flex;
		justify-content: center;
		align-items: center;
  }	
	.video_box .item-status-label {
	    position: absolute;
	    right: -15px;
		 top: -6px;
		 width: 40px;
		 height: 24px;
	    background: #13ce66;
	    text-align: center;
		 color: #ffffff;
	    transform: rotate(45deg);
	    box-shadow: 0 0 1pc 1px rgba(0, 0, 0, .2);
		 .el-icon-upload-success{
				color: #ffffff;
				margin-top: 8px;
				font-size: 16px;
				transform: rotate(-45deg);
		 }
	}
	.video_box .el-upload-list__item:first-child {
      margin-top: 0px !important;
	}
	.icon_box_big{
		  position: absolute;
		  width: 100%;
		  height: 100%;
		  top: 0;
		  left: 0;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  .icon_box_show{
			  display: none;
		  }
		  &:hover{
			  background-color: rgba(0, 0, 0, 0.3);
				.icon_box_show{
				  display: block;
				}
			  }
		  .icon_box{
			  display: flex;
			  color: #ffffff;
			  .icon{
					width: 35px;
					height: 35px;
					cursor: pointer;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 18px;
				  color: #f5f5f5;
			  }
		  }
		
	}
	
	@media only screen and (min-width: 1023px) {
		::v-deep .el-dialog__body{
			padding: 10px 20px;
		}
		::v-deep .el-dialog__headerbtn{
			top: 15px;
			right: 15px;
		}
		::v-deep .el-dialog__headerbtn .el-dialog__close {
		   font-size: 32px;
		}
	}
	@media only screen and (max-width: 1023px) {
		::v-deep .el-dialog__body{
			padding: 10px 10px;
		}
		::v-deep .el-dialog__headerbtn{
			top: 10px;
			right: 10px;
		}
		::v-deep .el-dialog__headerbtn .el-dialog__close {
		   font-size: 28px;
		}
	}
</style>
<style>
	.video_box_big.upload-image-wrapper .el-upload-list{
		display: none !important;
		height: 0px;
		width: 0px;
		overflow: hidden;
	}
	.video_box_big>div:first-child {
		height: 0px;
	}
</style>